export default __webpack_public_path__ + "static/media/done.ac127967.svg";